// Cognito session
function getCurrentUserSessionID() {
  return localStorage.getItem(`CognitoIdentityServiceProvider.${import.meta.env.VITE_USER_POOL_CLIENT_ID}.LastAuthUser`)
}

export function getCurrentUserSessionAccessToken() {
  const userID = getCurrentUserSessionID()
  return localStorage.getItem(
    `CognitoIdentityServiceProvider.${import.meta.env.VITE_USER_POOL_CLIENT_ID}.${userID}.accessToken`
  )
}

export function saveUserDetails(user) {
  const userID = getCurrentUserSessionID()
  localStorage.setItem(`AuthProvider.${userID}.user`, JSON.stringify(user))
}

export function getUserDetails() {
  const userID = getCurrentUserSessionID()
  const user = localStorage.getItem(`AuthProvider.${userID}.user`)
  return user ? JSON.parse(user) : null
}

export function removeUserDetails() {
  const userID = getCurrentUserSessionID()
  localStorage.removeItem(`AuthProvider.${userID}.user`)
}

export function isSessionExpired() {
  return localStorage.getItem('isSessionExpired') === 'true'
}

export function setSessionExpired(bool) {
  return localStorage.setItem('isSessionExpired', bool)
}
